import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";

const initialState: LedState = {
  brightness: undefined,
};

const getters: GetterTree<LedState, RootState> = {
  brightness(state: LedState): LedBrightness | undefined {
    return state.brightness;
  },
};

const mutations: MutationTree<LedState> = {
  RESET(state: LedState) {
    state.brightness = undefined;
  },

  SET_BRIGHTNESS(state: LedState, payload: LedBrightness) {
    state.brightness = payload;
  },
};

const actions: ActionTree<LedState, RootState> = {
  reset({ commit }) {
    commit("RESET");
  },
  read({ commit, rootState, state }) {
    if (state.brightness) {
      return new Promise((resolve) => resolve(this.getters["led/brightness"]));
    }

    return rootState.api
      .get(`led`)
      .then((response: { data: LedBrightness }) => {
        commit("SET_BRIGHTNESS", response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },
  update({ commit, rootState }, payload: LedBrightness) {
    return rootState.api
      .put(`led`, payload)
      .then((response: { data: LedBrightness }) => {
        if (response.data && Object.keys(response.data).length > 0) {
          commit("SET_BRIGHTNESS", response.data);
        }

        return Promise.resolve(response.data);
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
